










import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Divider extends Vue {
  @Prop({ default: "changehere" }) icon!: string;
}
